// extracted by mini-css-extract-plugin
module.exports = {"left":"splitter_left__NCzwX","right":"splitter_right__hLrOW","inner":"splitter_inner__IjqT1","resizing":"splitter_resizing__eY976","move-overlay":"splitter_move-overlay__kQpH_"};